import React, { useEffect, useState }   from 'react';
//import { Grid } from "@mui/material"
import Grid from '@mui/material/Unstable_Grid2';
import { useRecoilCallback, useRecoilValue, useSetRecoilState, useRecoilState } from "recoil"
import AutocompleteSkeleton from "src/shared/components/skeletons/AutocompleteSkeleton"
import useCatchErrorApi from "src/shared/hooks/useCatchErrorApi"
import AutocompletePrevision from "./components/autocompletes/AutocompletePrevision"
import AutocompleteProfessionals from "./components/autocompletes/AutocompleteProfessionals"
import AutocompleteSpecialities from "./components/autocompletes/AutocompleteSpecialities"
import AutocompleteSucursales from "./components/autocompletes/AutocompleteSucursales"
import AutocompleteBranch from "./components/autocompletes/AutocompleteBranch"

import AutocompleteAtencion from "./components/autocompletes/AutocompleteTipoConsulta"

import AutocompleteTipoExamen from "./components/autocompletes/AutocompleteTipoExamen"
import AutocompleteExamen from "./components/autocompletes/AutocompleteExamen"

import AutocompleteServicio from "./components/autocompletes/AutocompleteServicio"
import AutocompleteProcedimiento from "./components/autocompletes/AutocompleteProcedimiento"

import { covenantsFetchState, covenantsState, professionalsBySpecialityState, professionalsState, specialitiesFetchState, specialitiesState, sucursalesFetchState, sucursalesState, clinicasState, clinicasFetchState, atencionState, atencionFetchState, serviciosFetchState, procedimientosState, serviciosState, procedimientosFetchState } from "./components/autocompletes/state/atoms"
import { filterSearchSelectedState, isChangeFormSearchState, activeTabState } from "./state/atoms"

import { tipoExamenState, tipoExamenesFetchState, examenState, examenesFetchState, ExamenByTipoExamenState } from "./components/autocompletes/state/atoms"

const FormSearch = ({ size = "small", md = 12,  xs = 12, styles = {}, buttonSearch = null }) => {
    const { catchErrorApi } = useCatchErrorApi();
    const setIsChangeFormSearch = useSetRecoilState(isChangeFormSearchState);
    const filterSearchSelected = useRecoilValue(filterSearchSelectedState);
    const setCovenants = useSetRecoilState(covenantsState);
    const setProfessionals = useSetRecoilState(professionalsState);
    const setSpecialities = useSetRecoilState(specialitiesState);
    const setSucursales = useSetRecoilState(sucursalesState);
    const setClinicas = useSetRecoilState(clinicasState);
    const setAtencion = useSetRecoilState(atencionState);
    const setProcedimientos = useSetRecoilState(procedimientosState);
    const setServicios = useSetRecoilState(serviciosState);

    const setTipoExamen = useSetRecoilState(tipoExamenState);
    const setExamen = useSetRecoilState(examenState);

    const [loading, setLoading] = useState(false);

    const [hidden, setHidden] = useState(true);
    const [activeTabSearch, setActiveTabSearch] = useRecoilState(activeTabState);

    const loadData = useRecoilCallback(({ snapshot }) => async () => {
        const release = snapshot.retain();
        setLoading(true)
        try {
            console.log('🔥🔥🔥FormSearchCentral index ==> 🔥🔥🔥', activeTabSearch ) 
            if(activeTabSearch == 1){
                const atencionFetch = snapshot.getPromise(atencionFetchState); 
                const clinicasFetch = snapshot.getPromise(clinicasFetchState); 
                const sucursalesFetch = snapshot.getPromise(sucursalesFetchState); 
                const specialitiesFetch = snapshot.getPromise(specialitiesFetchState);
                const professionalsFetch = snapshot.getPromise(professionalsBySpecialityState(filterSearchSelected.specialitySelected.value));
                const covenantsFetch = snapshot.getPromise(covenantsFetchState);
                const responses = await Promise.all([
                    clinicasFetch,
                    sucursalesFetch,
                    specialitiesFetch,
                    professionalsFetch,
                    covenantsFetch,
                    atencionFetch,
                ]);
                setClinicas(responses[0])
                setSucursales(responses[1])
                setSpecialities(responses[2])
                if(filterSearchSelected.specialitySelected.value === ""){
                    setProfessionals(responses[3])
                }
                setCovenants(responses[4])
                setAtencion(responses[5])
            }

            if(activeTabSearch == 2){
                console.log("CLICK TAB IMG")
                // const clinicasFetch = snapshot.getPromise(clinicasFetchState); 
                // const sucursalesFetch = snapshot.getPromise(sucursalesFetchState);             
                const tipoExamenesFetch = snapshot.getPromise(tipoExamenesFetchState);
                const examenesFetch = snapshot.getPromise(ExamenByTipoExamenState(filterSearchSelected.tipoExamenSelected.code));
                console.log("TIPO EXAMEN SELECTED => ", filterSearchSelected.tipoExamenSelected.code );
                const responses = await Promise.all([
                    // clinicasFetch,
                    // sucursalesFetch,
                    tipoExamenesFetch,                
                    examenesFetch,
                ]);
                // setClinicas(responses[0])
                // setSucursales(responses[1])
                setTipoExamen(responses[0])
                setExamen(responses[1])
            }

            if(activeTabSearch == 3){
                const serviciosFetch = snapshot.getPromise(serviciosFetchState);
                const responses = await Promise.all([
                    serviciosFetch,
                ]);
                setServicios(responses[0])
                if (filterSearchSelected.servicioSelected.code != null){
                    const procedimientosFetch = await snapshot.getPromise(procedimientosFetchState);
                    setProcedimientos(procedimientosFetch)
                }
            }

        } catch (error) {
            catchErrorApi(error)
        } finally {
            setLoading(false)
            release()
        }
    }, []);

    useEffect(() => {
        loadData()

        return () => {
            loadData()
        }
    }, [loadData])

    useEffect(() => {
        return () => {
            setIsChangeFormSearch(false);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const myFunction = useRecoilCallback(({ snapshot }) => async (obj) => {
        console.log("myFunction response...", obj.ptD_NOMBRE);
        const examenesFetch = snapshot.getPromise(ExamenByTipoExamenState(obj.ptD_RUT));
        const responses = await Promise.all([
            examenesFetch,
        ]);
        console.log(responses[0])
        setExamen(responses[0]) 

    }, []);

    return (
        <Grid container spacing={3}>
            {/* { console.log('FormSearchCentral style ==> ', styles ) } */}
            <Grid item md={md} xs={xs} bottom>
                {loading ? <AutocompleteSkeleton /> : <AutocompleteAtencion size={size} styles={{ ...styles }} />}
            </Grid>                
            <Grid item md={md} xs={xs} bottom>
                {loading ? <AutocompleteSkeleton /> : <AutocompleteBranch size={size} styles={{ ...styles }} />}
            </Grid>            
            <Grid item md={md} xs={12} bottom hidden={activeTabSearch == 1 ? false : true}>
                {loading ? <AutocompleteSkeleton /> : <AutocompleteSucursales size={size} styles={{ ...styles }} />}
            </Grid>

            <Grid item md={md} xs={12} bottom hidden={activeTabSearch == 1 ? false : true}>
                {loading ? <AutocompleteSkeleton /> : <AutocompleteSpecialities size={size} styles={{ ...styles }} />}
            </Grid>

            <Grid item md={md} xs={12} hidden={activeTabSearch == 1 ? false : true} >
                {loading ? <AutocompleteSkeleton /> : <AutocompleteProfessionals size={size} styles={{ ...styles }} />}
            </Grid>

            <Grid item md={md} xs={12} hidden={activeTabSearch == 1 ? false : true } >
                {loading ? <AutocompleteSkeleton /> : <AutocompletePrevision size={size} styles={{ ...styles }} />}
            </Grid>

            <Grid item md={md} xs={12} bottom hidden={activeTabSearch == 2 ? false : true } >
                {loading ? <AutocompleteSkeleton /> : <AutocompleteTipoExamen size={size} styles={{ ...styles }} myEvent={myFunction} />}
            </Grid>

            <Grid item md={md} xs={12} hidden={activeTabSearch == 2 ? false : true } >
                {loading ? <AutocompleteSkeleton /> : <AutocompleteExamen size={size} styles={{ ...styles }} />}
            </Grid>

            <Grid item md={md} xs={12} hidden={activeTabSearch == 3 ? false : true } >
                {loading ? <AutocompleteSkeleton /> : <AutocompleteServicio size={size} styles={{ ...styles }} />}
            </Grid>
            <Grid item md={md} xs={12} hidden={activeTabSearch == 3 ? false : true } >
                {loading ? <AutocompleteSkeleton /> : <AutocompleteProcedimiento size={size} styles={{ ...styles }} />}
            </Grid>
            

            {
                buttonSearch && (
                    <Grid display={"flex"} justifyContent="center" alignItems={"center"} item md={md} xs={12}>
                        {buttonSearch}
                    </Grid>
                )
            }
        </Grid>
    )
}

export default FormSearch
